module.exports = __webpack_public_path__ + "static/media/Union 1.cf73acfd.svg";